/* eslint-disable */
'use client';

import * as React from 'react';
import { Input as CoreInput, cn } from '@newfront-insurance/core-ui/v2';

type ArtifactPreviewInputSize = 'default' | 'lg' | 'sm' | number;

export interface ArtifactPreviewInputProps extends Omit<React.ComponentProps<typeof CoreInput>, 'className' | 'size'> {
  className?: string;
  nativeInput?: boolean;
  size?: ArtifactPreviewInputSize;
  unstyled?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, ArtifactPreviewInputProps>(
  (
    {
      className,
      inputClassName,
      nativeInput: _nativeInput,
      size = 'default',
      unstyled = false,
      wrapperClassName,
      ...props
    },
    ref,
  ) => {
    const compact = size === 'sm';
    const large = size === 'lg';

    return (
      <CoreInput
        ref={ref}
        wrapperClassName={cn(
          compact && 'h-8 rounded-[6px]',
          large && 'h-11',
          unstyled && 'border-0 bg-transparent shadow-none',
          className,
          wrapperClassName,
        )}
        inputClassName={cn(compact && 'px-2 py-1 text-sm', large && 'py-2.5', inputClassName)}
        {...props}
      />
    );
  },
);

Input.displayName = 'ArtifactPreviewInput';
